import React, { Component, createRef } from "react";
import { v4 as uuid } from "uuid";

import styled from "styled-components";
import { $, _ } from "js/vendor";
import { themeColors } from "js/react/sharedStyles";
import { DialogActions, DialogTitle, Icon } from "@mui/material";
import BeautifulDialog from "../../../../react/components/Dialogs/BeautifulDialog";
import { DialogContent, ShowDialog, ShowDialogAsync, ShowWarningDialog } from "../../../../react/components/Dialogs/BaseDialog";
import { Button } from "js/Components/Button";
import { ColorChit, ColorfulChit, ThemeColorChit } from "js/Components/ColorChit";
import { Theme } from "../../../../core/models/theme";
import { WithLabel } from "js/Components/WithLabel";
import { Dropdown } from "js/Components/Dropdown";
import { MenuItem, MenuItemDetails, MenuItemWithDetails } from "js/Components/Menu";
import { ColorPicker, ColorSet } from "js/Components/ColorPickers/ColorPicker";
import { FlexBox, GridBox } from "../../../../react/components/LayoutGrid";
import { IconButton } from "js/Components/IconButton";
import { FlexSpacer, Gap20, Gap30, Gap5 } from "../../../../react/components/Gap";
import { ToolTip } from "../../../../Components/ToolTip";
import { PropertyPanelContainer, PropertySection, PropertySectionHeader } from "../../../../EditorComponents/PropertyPanel";
import { PaletteColorType } from "../../../../../common/constants";
import { DialogSubtitle } from "../../../../react/components/Dialogs/DialogSubtitle";
import { Popup, PopupContent, PopupPreview } from "../../../../Components/Popup";
import { ChromePicker } from "react-color";

const DragColorChit = styled.div`
    position: relative;
    display: inline-block;
    float: left;

    .material-icons {
        opacity: 0;
        position: absolute;
        top: -4px;
        right: -4px;
        font-size: 16px;
        border-radius: 50%;
        background: white;
        cursor: pointer;
    }

    &:hover {
        .material-icons {
            opacity: 1
        }
    }
`;

const AddColorButton = styled.div`
    width: 24px;
    height: 24px;
    float: left;
    border-radius: 50%;
    border: 2px solid ${themeColors.ui_blue};
    display: flex;
    align-items: center;
    justify-content: center;
    //margin-top: 6px;
    //margin-left: 4px;

    &:hover {
        background: ${themeColors.ui_blue};

        & .material-icons {
            color: white
        }
    }

    & .material-icons {
        color: ${themeColors.ui_blue};
        font-weight: 800;
        font-size: 16px;
    }
`;

const ColorChitContainer = styled.div`
    position: relative;
    display: flex;
    gap: 5px;
    flex-wrap: wrap;
`;

export class CollectionColorList extends Component {
    constructor(props) {
        super();

        this.ref = createRef();

        let theme = new Theme(props.theme, { disconnected: true, autoLoad: false });
        theme.loadTheme();
        this.state = {
            theme,
            collectionColors: props.collectionColors,
            isDragging: false
        };
    }

    componentDidMount() {
        let $el = $(this.ref.current);
        $el.sortable({
            items: ".drag-chit",
            // axis: "x",
            start: event => this.setState({ isDragging: true }),
            stop: (event, ui) => {
                let collectionColors = [];
                let $items = $el.find(".drag-chit");
                $items.each((index, item) => {
                    let id = $(item).data("id");
                    let collectionColor = this.state.collectionColors.find(color => color.id === id);
                    if (collectionColor) {
                        collectionColors.push(collectionColor);
                    }
                });
                this.setState({ collectionColors, isDragging: false });
                this.saveCollectionColors();
            }
        });
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.theme.colors !== prevProps.theme.colors) {
            let theme = new Theme(this.props.theme, { disconnected: true, autoLoad: false });
            theme.loadTheme();
            this.setState({ theme });
        }
        if (this.props.collectionColors !== prevProps.collectionColors) {
            this.setState({ collectionColors: this.props.collectionColors });
        }
    }

    handleAddCollectionColor = async () => {
        const { theme } = this.state;

        let collectionColor = await ShowDialogAsync(CollectionColorEditor, { theme });
        if (collectionColor) {
            const { collectionColors } = this.state;
            collectionColors.push(collectionColor);
            this.setState({ collectionColors });
            this.saveCollectionColors();
        }
    }

    handleEditCollectionColor = async collectionColor => {
        const { theme } = this.state;

        let newProps = await ShowDialogAsync(CollectionColorEditor, { collectionColor, theme });
        collectionColor = Object.assign(collectionColor, newProps);

        this.saveCollectionColors();
    }

    handleRemoveCollectionColor = collectionColor => {
        const { collectionColors } = this.state;
        const index = collectionColors.findIndex(color => color.id === collectionColor.id);
        if (index !== -1) {
            collectionColors.splice(index, 1);
            this.setState({ collectionColors });

            this.saveCollectionColors();
        }
    }

    saveCollectionColors() {
        const { collectionColors } = this.state;
        const { onUpdate } = this.props;
        if (onUpdate) {
            onUpdate(collectionColors);
        }
    }

    render() {
        const { theme, collectionColors, isDragging } = this.state;

        return (
            <ColorChitContainer ref={this.ref}>
                {collectionColors.map((collectionColor, index) => (
                    <DragColorChit key={collectionColor.id} className="drag-chit" data-id={collectionColor.id}>
                        <ColorChit theme={theme}
                            color={theme.palette.getCollectionColorPreviewColors(collectionColor)}
                            type="colorful"
                            size={35}
                            onClick={() => this.handleEditCollectionColor(collectionColor)}
                            onRemove={() => this.handleRemoveColor(index)}
                        />
                        <Icon onClick={() => this.handleRemoveCollectionColor(collectionColor)}>cancel</Icon>
                    </DragColorChit>
                ))}

                {collectionColors.length < 10 && !isDragging && (
                    <AddColorButton id="add-color" onClick={this.handleAddCollectionColor} style={{ marginTop: 6, marginLeft: 6 }}>
                        <Icon color="primary">add</Icon>
                    </AddColorButton>
                )}
            </ColorChitContainer>
        );
    }
}

const PreviewItem = styled.div`
    background: ${props => props.background};
    color: ${props => props.forecolor};
    font-size: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    width: ${props => props.size}px;
    height: ${props => props.size}px;
`;

const AutoLightDarkChit = styled(ColorfulChit)`
    transform: rotate(45deg);

    &:after {
        transform: rotate(-45deg);
        mix-blend-mode: difference;
    }
`;

class CollectionColorEditor extends Component {
    constructor(props) {
        super(props);

        let theme = props.theme;
        let collectionColor = props.collectionColor;

        this.state = {
            id: collectionColor?.id ?? uuid(),
            type: collectionColor?.type ?? "sequence",
            startColor: collectionColor?.startColor ?? "theme",
            endColor: collectionColor?.endColor ?? "accent1",
            colors: [...(collectionColor?.colors ?? Object.keys(theme.palette.getSlideColors()))],
            overrideBackgroundColor: collectionColor?.overrideBackgroundColor ?? null
        };
    }

    handleSave = () => {
        const { id, type, startColor, endColor, colors, overrideBackgroundColor } = this.state;
        let collectionColor = {
            id,
            type,
            startColor,
            endColor,
            colors,
            overrideBackgroundColor
        };
        this.props.closeDialog(collectionColor);
    }

    getPreviewBackgroundColor(index, count) {
        return this.props.theme.palette.getCollectionColor(this.state, index, count);
    }

    render() {
        const { theme } = this.props;
        const { type, startColor, endColor, colors, overrideBackgroundColor } = this.state;

        let canvas = {
            getTheme: () => theme,
            getBackgroundColor: () => theme.palette.getColor("white")
        };

        let previewItemCount = Math.max(8, type == "sequence" ? colors.length : 6);

        return (
            <BeautifulDialog closeDialog={this.props.closeDialog} fullWidth={false} maxWidth="lg">
                <DialogTitle style={{ width: 820 }}>
                    Edit Collection Color
                    <DialogSubtitle>
                        <p>Collection Colors can be used to color the items in a collection, such as the shapes behind icons in an Icon with Text slide, the bullet points in Bullet Point slide, or the sections in a Pyramid slide.</p>
                    </DialogSubtitle>
                </DialogTitle>
                <DialogContent style={{ width: 820 }}>
                    <PropertySection fullWidth>
                        <WithLabel label="Type" tight>
                            <Dropdown value={type} onChange={type => this.setState({ type })}>
                                <MenuItemWithDetails value="sequence">
                                    Sequence
                                    <MenuItemDetails>
                                        Colors each item using the colors defined in a repeating sequence.
                                        <Gap5 />
                                        <FlexBox left gap={5}>
                                            {Object.keys(theme.palette.getSlideColors()).slice(0, 3).map((color, index) => (
                                                <ColorChit key={index} color={theme.palette.getColor(color)} size={20} />
                                            ))}
                                            {Object.keys(theme.palette.getSlideColors()).slice(0, 2).map((color, index) => (
                                                <ColorChit key={index} color={theme.palette.getColor(color)} size={20} />
                                            ))}
                                        </FlexBox>
                                    </MenuItemDetails>
                                </MenuItemWithDetails>
                                <MenuItemWithDetails value="gradient">
                                    Gradient
                                    <MenuItemDetails>
                                        Colors each item using a gradient from the start color to the end color.
                                        <Gap5 />
                                        <FlexBox left gap={5}>
                                            {[...Array(5)].map((_, index) => (
                                                <ColorChit key={index} color={
                                                    theme.palette.getShadedColor(theme.palette.getColor("theme"), theme.palette.getColor("accent1"), index, 5)
                                                } size={20} />
                                            ))}
                                        </FlexBox>
                                    </MenuItemDetails>
                                </MenuItemWithDetails>
                            </Dropdown>
                        </WithLabel>
                        <Gap20 />

                        <FlexBox left top height={100} fillWidth>

                            {type == "gradient" && (
                                <WithLabel label="Gradient" left above>
                                    <GradientColorsEditor canvas={canvas} showColorPicker
                                        startColor={startColor}
                                        endColor={endColor}
                                        onChange={value => this.setState({ startColor: value.split("-to-")[0], endColor: value.split("-to-")[1] })}
                                    />
                                </WithLabel>
                            )}
                            {type == "sequence" && (
                                <WithLabel label="Sequence Colors" left above>
                                    <SequenceColorsEditor canvas={canvas}
                                        colors={colors}
                                        onChange={colors => this.setState({ colors })}
                                    />
                                </WithLabel>
                            )}

                            <Gap30 />
                            <Gap30 />

                            <WithLabel label="ForeColor" left above
                                toolTip="Often there will be text and/or an icon placed on top of the collection color, so you can set the forecolor to automatically choose light or dark colors depending on the background or force the forecolor to light or dark if consistency across all items is preferable."
                            >
                                <FlexBox gap={10} left>
                                    <WithLabel small below center label="Auto">
                                        <AutoLightDarkChit
                                            size={35}
                                            onClick={() => this.setState({ overrideBackgroundColor: null })}
                                            selected={overrideBackgroundColor === null}
                                            overlayLetter="AUTO"
                                        >
                                            {["#f1f1f1", "#111"].map((color, index) => (<div key={index} style={{ background: color }} />))}
                                        </AutoLightDarkChit>
                                    </WithLabel>
                                    <WithLabel small below center label="Light">
                                        <ColorChit color="white" size={35}
                                            onClick={() => this.setState({ overrideBackgroundColor: PaletteColorType.BACKGROUND_DARK })}
                                            selected={overrideBackgroundColor === PaletteColorType.BACKGROUND_DARK}
                                        />
                                    </WithLabel>
                                    <WithLabel small below center label="Dark">
                                        <ColorChit color="black" size={35}
                                            onClick={() => this.setState({ overrideBackgroundColor: PaletteColorType.BACKGROUND_LIGHT })}
                                            selected={overrideBackgroundColor === PaletteColorType.BACKGROUND_LIGHT}
                                        />
                                    </WithLabel>
                                </FlexBox>
                            </WithLabel>
                        </FlexBox>
                    </PropertySection>
                    <Gap20 />
                    <PropertySection fullWidth>
                        <WithLabel label="Preview" above left>
                            <FlexBox gap={10} left>
                                {[...Array(previewItemCount)].map((_, index) => (
                                    <PreviewItem key={index}
                                        size={previewItemCount < 9 ? 85 : 65}
                                        background={this.getPreviewBackgroundColor(index, previewItemCount)}
                                        forecolor={theme.palette.getColor("primary", overrideBackgroundColor ? theme.palette.getColor(overrideBackgroundColor) : this.getPreviewBackgroundColor(index, previewItemCount))}
                                    >{index + 1}</PreviewItem>
                                ))}
                            </FlexBox>
                        </WithLabel>
                    </PropertySection>
                </DialogContent>
                <DialogActions>
                    <Button large unframed onClick={() => this.props.closeDialog()}>Cancel</Button>
                    <Button large blue onClick={this.handleSave}>Save</Button>
                </DialogActions>
            </BeautifulDialog>
        );
    }
}

export class GradientColorsEditor extends Component {
    render() {
        const { canvas, onChange, startColor, endColor, showColorPicker } = this.props;

        return (
            <FlexBox gap={10} left width={120}>
                <WithLabel small below center label="Start">
                    <ColorPicker canvas={canvas} size={35}
                        value={startColor ?? "theme"}
                        showColorPicker={showColorPicker} showWhite showBlack disableAlpha
                        customColors={[{ label: "Light", value: "white" }, { label: "Dark", value: "black" }]}
                        onChange={color => onChange(color + "-to-" + this.props.endColor)}
                    />
                </WithLabel>
                <WithLabel small below center label="End">
                    <ColorPicker canvas={canvas} size={35}
                        value={endColor ?? "white"}
                        showColorPicker={showColorPicker} showWhite showBlack disableAlpha
                        customColors={[{ label: "Light", value: "white" }, { label: "Dark", value: "black" }]}
                        onChange={color => {
                            onChange(this.props.startColor + "-to-" + color);
                        }}
                    />
                </WithLabel>
            </FlexBox>
        );
    }
}

class SequenceColorsEditor extends Component {
    constructor(props) {
        super(props);

        this.ref = React.createRef();
        this.state = {
            isDragging: false,
            customColor: null
        };
    }

    componentDidMount() {
        let $el = $(this.ref.current);
        $el.sortable({
            items: ".drag-chit",
            axis: "x",
            start: event => this.setState({ isDragging: true }),
            stop: (event, ui) => {
                this.setState({ isDragging: false });
                this.props.onChange(_.map($el.find(".drag-chit"), chit => {
                    return $(chit).attr("data-color");
                }));
            }
        });
    }

    handleSelectRawColor = (color, event) => {
        const eventTargetId = event.target.id;
        // In react-color, there is a bug, where it does not deselect the input (if it's selected),
        // and if in a case a user would like to see the color reflected in the input we need to blur it.
        if (!eventTargetId.contains("rc-editable-input")) {
            $(".chrome-picker [id*=rc-editable-input]").trigger("blur");
        }

        event.preventDefault();
        event.stopPropagation();

        if (event.nativeEvent) {
            event.nativeEvent.preventDefault();
            event.nativeEvent.stopImmediatePropagation();
        }

        const customColor = `rgba(${color.rgb.r},${color.rgb.g},${color.rgb.b},${color.rgb.a})`;

        // In react-color there is a bug where the alpha value is not set correctly when the color is selected from the color picker.
        // Some explanation about it: https://github.com/casesandberg/react-color/issues/432
        // Basically when we open the picker, it is already set to be an rgba color, however when we select the text input of the picker,
        // it passes it as a rgba string which is not correct (This field accepts HEX values).
        // Here is the workaround for this issue:
        // If the alpha value is not 1, we assume it's an HEX.
        // If the alpha value is 1, we assume it's an RGBA.

        if (color.rgb.a !== 1) color = _.cloneDeep(color.rgb);
        else color = color.hex;

        this.setState({
            customColor,
        });
    };

    handleAddColor = color => {
        if (!color) return;

        const { colors, onChange } = this.props;
        colors.push(color);
        onChange(colors);
    }

    handleChangeColor = (index, color) => {
        if (!color) return;

        const { colors, onChange } = this.props;
        colors[index] = color;
        onChange(colors);
    }

    handleRemoveColor = index => {
        const { colors, onChange } = this.props;
        if (colors.length <= 2) {
            return ShowWarningDialog({ title: "Sorry, can't delete this color", message: "You need at least 2 colors in the sequence." });
        }
        colors.splice(index, 1);
        onChange(colors);
    }

    render() {
        const { colors, canvas } = this.props;
        const { isDragging, customColor } = this.state;

        const theme = canvas.getTheme();
        const themeColors = theme.palette.getSlideColors();

        return (
            <ColorChitContainer ref={this.ref}>
                {colors.map((color, index) => (
                    <DragColorChit data-color={color} key={color} className="drag-chit">
                        <ColorPicker canvas={canvas}
                            value={color}
                            size={35}
                            showColorPicker disableAlpha saveOnClose={true}
                            onChange={color => this.handleChangeColor(index, color)}
                            onRemove={() => this.handleRemoveColor(index)}
                        />
                        <Icon onClick={() => this.handleRemoveColor(index)}>cancel</Icon>
                    </DragColorChit>
                ))}

                {colors.length < 10 && (
                    <Popup>
                        <PopupPreview>
                            <FlexBox width={35} center middle>
                                <AddColorButton>
                                    <Icon color="primary">add</Icon>
                                </AddColorButton>
                            </FlexBox>
                        </PopupPreview>
                        <PopupContent>
                            {closePopup => (
                                <PropertyPanelContainer>
                                    <PropertySection>
                                        <FlexBox gap={5} left>
                                            <ColorSet>
                                                <WithLabel small below left label="Theme Colors">
                                                    <GridBox columns gap={5}>
                                                        {Object.keys(themeColors).map(color => (
                                                            <ThemeColorChit key={color}
                                                                color={color}
                                                                theme={theme}
                                                                size={35}
                                                                onClick={() => {
                                                                    this.handleAddColor(color);
                                                                    closePopup();
                                                                }} />
                                                        ))}
                                                    </GridBox>
                                                </WithLabel>
                                            </ColorSet>
                                            <ColorSet>
                                                <WithLabel small below left label="Custom">
                                                    <Popup onClose={() => {
                                                        this.handleAddColor(customColor);
                                                        this.setState({ customColor: null });
                                                        closePopup();
                                                    }}>
                                                        <PopupPreview>
                                                            <ColorChit type="picker" size={35} color={customColor} />
                                                        </PopupPreview>
                                                        <PopupContent>
                                                            <ChromePicker
                                                                disableAlpha
                                                                color={customColor ?? "white"}
                                                                style={{ boxShadow: "none" }}
                                                                onChange={this.handleSelectRawColor}
                                                            />
                                                        </PopupContent>
                                                    </Popup>
                                                </WithLabel>
                                            </ColorSet>
                                        </FlexBox>
                                    </PropertySection>
                                </PropertyPanelContainer>
                            )}
                        </PopupContent>
                    </Popup>
                )}

            </ColorChitContainer>
        );
    }
}
